import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '@material-ui/core/Button';
import Conf from 'utils/Conf';

import './VideoMediaCard.scss';

function VideoMediaCard({
  banner = '',
  endDate = false,
  title = '',
  description = '',
  width = 200,
  thumbnail = '',
  onClick,
}) {
  const {t} = useTranslation();
  const [openDescription, setOpenDescription] = useState(false);

  const remainingDays = Math.ceil((new Date(endDate) - new Date()) / (1000 * 3600 * 24));

  return (
    <div className="VideoMediaCard-container" style={{width: width}}>
      <div className="VM-thumb-container" onClick={onClick}>
        <img src={`${Conf.assetsRoot}${thumbnail}`} alt="thumbnail" />
        {banner?.length > 0 && <div className="VM-thumb-newheader">{banner.toUpperCase()}</div>}
        {endDate && <div className="VM-thumb-countdown">{t('j-restants', {remainingDays})}</div>}
      </div>
      <p className="VM-title">{title}</p>
      <p className={openDescription ? 'VM-description opened' : 'VM-description'}>{description}</p>
      {description?.length > 58 && (
        <Button className="VM-more" onClick={() => setOpenDescription(!openDescription)}>
          {openDescription ? t('--d-infos') : t('+-d-infos')}
        </Button>
      )}
    </div>
  );
}

export default VideoMediaCard;
